import { useCallback, useEffect, useMemo, useState, useRef} from 'react'
import useStyles from '../../styles/global-mui.js';
import { useTheme } from '@mui/material/styles';
import {Button, Card, List, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, useMediaQuery} from '@mui/material'
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

import { FixedSizeList as VirtualizedList } from 'react-window'

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

import { useDispatch } from 'react-redux'

import { Box, FormControl, Grid, InputLabel, MenuItem, Select} from '@mui/material';
import Select_Dsas from '../../dsasComponents/Select_Dsas.js';
import { updateMatch } from '../../actions/matchs.js';

import * as api from '../../api'
import { getActualSeason, getDays, season_all } from '../../bdd/bddSTUB.js';
import { getUserProvider } from '../../actions/auth.js';
import SelectGroupProvider from '../../dsasComponents/SelectGroupProvider.js';

import { discipline_all } from '../../bdd/bddSTUB.js'
import { useFetch } from '../../filters/useFetch.js';
import { FETCH_ALL_COMPETITION, FETCH_ALL_TEAM } from '../../constants/actionTypes.js';
import { Can } from '../../permissions/Can.js';
import { PERMISSIONS } from '../../permissions/permissionKeys.js';
import { usePermissions } from '../../permissions/usePermissions.js';
import DsasButton from '../../v1/components/DsasButton/DsasButton.js';
import { formatDateOnly, formatTimeOnly, getTodayDate, toUTCISOString } from './dateUtils.js';
import { faAngleDown, faAngleUp, faDownload } from '@fortawesome/free-solid-svg-icons';

    const isRowValid = (row) => {
      const homeOk = !!row.homeTeam;
      const awayOk = !!row.awayTeam;
      // optionnel : empêcher même équipe
      const notSame = !row.homeTeam || !row.awayTeam || row.homeTeam !== row.awayTeam;

      return homeOk && awayOk && notSame;
    };

    const getRowErrors = (row) => {
      const errors = {};
      if (!row.homeTeam) errors.homeTeam = 'Équipe domicile obligatoire';
      if (!row.awayTeam) errors.awayTeam = 'Équipe extérieure obligatoire';
      if (row.homeTeam && row.awayTeam && row.homeTeam === row.awayTeam) {
        errors.homeTeam = 'Les équipes doivent être différentes';
        errors.awayTeam = 'Les équipes doivent être différentes';
      }
      return errors;
    };

const Calendar = () => {

    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [competition, setCompetition] = useState()
    const [matchs, setMatchs]= useState()

    const [provider, setProvider] = useState(getUserProvider())
    const [discipline, setDiscipline] = useState('')
    const [season, setSeason] = useState(getActualSeason())
    const { getPermission } = usePermissions();
    const providerPermission = getPermission(PERMISSIONS.FILTER_PROVIDER);

    const [editedRows, setEditedRows] = useState([])
    const [rowErrors, setRowErrors] = useState({}); // { [rowId]: { homeTeam?: string, awayTeam?: string } }
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const emptyFilter = useMemo(() => ({ provider, discipline, season }), [provider, discipline, season]);

    useEffect(() => {
      setEditedRows([]);
      setRowErrors({});
    }, [provider, discipline, season]);

    
    const [competitions] = useFetch(api.fetchCompetitions, emptyFilter, ['season', 'discipline', 'provider'], FETCH_ALL_COMPETITION)

    const teamsFilter = useMemo(() => {
        return {competition : competition?._id}
    }, [competition])

    const [teams, _ , resetTeams] = useFetch(api.fetchTeams, teamsFilter, ['competition'], FETCH_ALL_TEAM)

    const hasInvalidEditedRow = useMemo(() => {
      return editedRows.some(r => !isRowValid(r));
    }, [editedRows]);


    useEffect(() => {
        setMatchs([])
        resetTeams()
        setEditedRows([]);
        const fetchMatchs = async () => {
            if (competition && competition._id) {
            try {
                const { data } = await api.fetchMatchsByCompetition(competition._id);
                setMatchs(data);
            } catch (error) {
                console.error("Erreur lors du fetch des matchs :", error);
                setMatchs([]);
            }
            } else {
            setMatchs([]);
            }
        };

        fetchMatchs();
    }, [competition]);


    useEffect(() => {
        setCompetition()

    }, [provider, discipline])

    const onChooseCompetition = (e) => {
        let choosedComp = competitions.find(c => c._id === e.target.value)

        setCompetition(choosedComp)
        setEditedRows([]);
        setRowErrors({})
    }

    const handleReset = () => {
      setEditedRows([]);
      setRowErrors({})
      setCompetition(s => ({...s}))
    }
    
    
    const handleResetRow = (rowId) => {
      setEditedRows(prev => prev.filter(r => r.rowId !== rowId));

      setRowErrors(prev => {
        const next = { ...prev };
        delete next[rowId];
        return next;
      });
    };

  
    const handleRowChange = (dataRow, name, value) => {
        setEditedRows((prev) => {
            const index = prev.findIndex((s) => s.rowId === dataRow.rowId);
            const baseRow = index !== -1 ? prev[index] : dataRow;

            const updatedRow = { ...baseRow };
            const currentDate = formatDateOnly(baseRow.dateTime);
            const currentTime = formatTimeOnly(baseRow.dateTime);

            if (name === 'date') {
            // On n’essaie de convertir en UTC que si la date est complète
            const newUTC = toUTCISOString(value, currentTime || '12:00');
            if (newUTC) updatedRow.dateTime = newUTC;
            } else if (name === 'time') {
            const newUTC = toUTCISOString(currentDate || getTodayDate(), value);
            if (newUTC) updatedRow.dateTime = newUTC;
            } else {
            updatedRow[name] = value;
            }

            setRowErrors((prevErr) => {
              const errs = getRowErrors(updatedRow);
              if (Object.keys(errs).length === 0) {
                const copy = { ...prevErr };
                delete copy[updatedRow.rowId];
                return copy;
              }
              return { ...prevErr, [updatedRow.rowId]: errs };
            });

            const newState = [...prev];
            if (index !== -1) {
            newState[index] = updatedRow;
            } else {
            newState.push(updatedRow);
            }

            return newState;
        });
    };

    const handleSave = async () => {

      //Checks validity
        const invalidRows = editedRows.filter(r => !isRowValid(r));

        if (invalidRows.length) {
          setRowErrors((prev) => {
            const next = { ...prev };
            for (const r of invalidRows) next[r.rowId] = getRowErrors(r);
            return next;
          });
          setLoading(false);
          return;
        }

        console.log('editedRows to be pushed to server:', editedRows)

      for (const editedRow of editedRows) {
        
        const { idMatch, day, dateTime, homeTeam, awayTeam } = editedRow;
        if (idMatch) {
          console.log('idMatch found, we update this one : ', editedRow)
          dispatch(updateMatch(idMatch, {
            day, dateTime, homeTeam, awayTeam,
            competition: competition._id,
            provider: competition.provider
          }));
        } else {
          console.log('idMatch not found, we create this one : ', editedRow)
          await api.createMatch({
            day, dateTime, homeTeam, awayTeam,
            competition: competition._id,
            provider: competition.provider
          });
        }
      }

      setLoading(false);
      
      handleReset();
    };

   const buildCsvFilters = () => {
    // Toujours renvoyer le provider réel si l’utilisateur n’a pas accès au sélecteur provider
    const safeProvider = providerPermission?.allowed ? provider : getUserProvider();

    return {
      provider: safeProvider || undefined,
      discipline: discipline || undefined,
      season: season || undefined,
      competition: competition?._id || undefined,
      // ajouter ici d’autres champs si on affine après (ex: teams sélectionnées)
    };
  };

  const handleExportCSV = async () => {
    try {
      const filters = buildCsvFilters();
      
      const res = await api.exportCalendars(filters);
      if (res.status !== 200) throw new Error('Erreur lors du téléchargement du CSV');

      const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);

      const filename = [
        'calendars',
        filters.provider || 'all_providers',
        filters.discipline || 'all_disciplines',
        competition?.name || 'all_competitions',
        (filters.season ? `saison_${filters.season}` : 'all_seasons').replace(/[^\w-]/g, '_')
      ].join('_') + '.csv';

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
      // tu peux brancher un toast/alert ici
    }
  };

    const classes = useStyles();

    const mantatoryFieldsInfo = 'Discipline, Compétition';

    return (
        <Box sx={{textAlign : 'center'}}>
             {/*PAGE TITLE*/}
            <Box className='centered-medium-wrapper'>
            <h1 className='page-title'>Gestion des calendriers</h1>
            </Box>
            <Box className='medium-separator'></Box>

            <Box className='small-padding'></Box>

                {/*SEARCH FILTERS*/}
                 <Box className='padding-wrapper'>
                    <Grid container spacing={1.5} sx={{alignItems : 'flex-end'}}>
                        {providerPermission?.allowed && ( 
                        <Grid item xs={12} sm={12} md>
                            {/* Groupe (Provider) */}
                            <SelectGroupProvider value={provider} onChange={(e) => setProvider(e.target.value)} className={classes.customInput}/>             
                        </Grid>
                        )}
                        <Grid item xs={12} sm={12} md>
                           {/*Discipline*/} 
                            <FormControl fullWidth className={classes.customInput}  error={!discipline}>
                                <InputLabel id={"disciplinecompet"}>Discipline</InputLabel>
                                <Select 
                                    labelId={'disciplinecompet'}
                                    id={"disciplinecompetselect"}
                                    name={'discipline'}
                                    value={discipline}
                                    label={'Discipline'}
                                    onChange={(e) => setDiscipline(e.target.value)}
                                >
                                    {discipline_all && discipline_all.map(i => (<MenuItem key={i._id} value={i._id}>{i.name ? i.name : `${i.lastname} ${i.firstname}`}</MenuItem>))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md>
                            {/*Season*/} 
                            <FormControl fullWidth className={classes.customInput} error={!season} >
                                <InputLabel id={"seasoncompet"}>Saison</InputLabel>
                                <Select 
                                    labelId={'seasoncompet'}
                                    id={"seasoncompetselect"}
                                    name={'season'}
                                    value={season}
                                    label={'Saison'}
                                    onChange={(e) => setSeason(e.target.value)}
                                >
                                    {season_all && season_all.map(i => (<MenuItem key={i._id} value={i._id}>{i.name ? i.name : `${i.lastname} ${i.firstname}`}</MenuItem>))}
                                </Select>
                            </FormControl>     
                        </Grid>
                        <Grid item xs={12} sm={12} md>
                            <Select_Dsas  
                            className={classes.customInput} 
                            sx={{}} 
                            label={"Compétition"} 
                            name="competition" 
                            items={competitions} 
                            value={competition?._id} 
                            onChange={onChooseCompetition}
                            isError={!(competition?._id)}
                            >
                            </Select_Dsas>             
                        </Grid>
                    </Grid>

                    {(!discipline || !season || !competition?._id) &&
                    <Box className='left-medium-wrapper'>{`Veuillez saisir les filtres obligatoires (${mantatoryFieldsInfo}).`}</Box>
                    }

                  {/* Bouton Export CSV */}
                  { getPermission(PERMISSIONS.SPORT_CALENDAR_HOME_BUTTON_EXPORTCSV).allowed && <>
                      <Box className='small-padding' />
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                          {/* UNCOMMENT TO ALLOW ALL COMPETTIONS CSV DOWNLOAD <DsasButton label="Exporter les résultats en CSV" icon={faDownload} onClick={handleExportCSV} variant = 'secondary' disabled={!discipline || !season } /> */}
                          <DsasButton 
                            label="Exporter les résultats en CSV" 
                            icon={faDownload} 
                            onClick={handleExportCSV} 
                            variant = 'secondary' 
                            disabled={!discipline || !season || !competition?._id} />
                        </Box>
                  </>
                }
            </Box>
            

              {isMobile ? (
                  <CalendarMobileList
                    competition={competition}
                    teams={teams}
                    matchs={matchs}
                    editedRows={editedRows}
                    handleRowChange={handleRowChange}
                    handleSave={handleSave}
                    setLoading={setLoading}
                    rowErrors={rowErrors}
                    hasInvalidEditedRow={hasInvalidEditedRow}
                    handleResetRow={handleResetRow}
                  />
                ) : (
                  <Box>
                  <CalendarGrid
                    competition={competition}
                    teams={teams}
                    matchs={matchs}
                    editedRows={editedRows}
                    handleRowChange={handleRowChange}
                    handleSave={handleSave}
                    setLoading={setLoading}
                    rowErrors={rowErrors}
                    hasInvalidEditedRow={hasInvalidEditedRow}
                    handleResetRow={handleResetRow}
                  /> </Box>
                )}
           
        </Box>
        
    );
}

const generateMatchData = (competition, teams, matchs) => {
    if (!competition) return [];

     const data = []
        const usedMatchs = []

        let rowId = 0

        const competitionDays = getDays(competition.nbDays, competition.nbTeamFinalPhase)
        const nbMatchPerStandardDay = Math.max(1, Math.ceil(teams.length/2))

        competitionDays.map(day => {
                const nbMatchPerDay = day.nbMatchPerDay ?? nbMatchPerStandardDay

                    for(var i=1 ; i <= nbMatchPerDay ; i++){
                        
                        const existingMatch = matchs.find(match => match.day == day.name && !usedMatchs.includes(match._id))
                        // Un match correspond a cette journée
                        if(existingMatch){
                            data.push({    
                                idMatch : existingMatch._id, 
                                day : existingMatch.day, 
                                dateTime : new Date(existingMatch.dateTime),
                                homeTeam : existingMatch.homeTeam, 
                                awayTeam : existingMatch.awayTeam,
                                rowId : rowId++})

                            usedMatchs.push(existingMatch._id)
                        }
                        // Aucun match ne correspond a cette journée
                        else{
                            data.push({    
                                idMatch : undefined, 
                                day : day.name, 
                                dateTime : new Date(), 
                                homeTeam : "", 
                                awayTeam : "",
                                rowId : rowId++})
                        }
                    }
        })

        return data
};

const CalendarMobileList = ({ competition, teams, matchs, editedRows, handleRowChange, setLoading, handleSave, hasInvalidEditedRow, rowErrors, handleResetRow }) => {
    const classes = useStyles()
    const data = useMemo(() => generateMatchData(competition, teams, matchs), [competition, teams, matchs]);

    if (!competition || !teams?.length) return null;

  return (
      <VirtualizedCardRow isDisabledEdition={competition.thirdPartyId && !['dsas'].includes(competition.thirdPartyId)} dataTable={data} editedRows={editedRows} teams={teams} classes={classes} handleRowChange={handleRowChange} setLoading={setLoading} handleSave={handleSave} rowErrors={rowErrors} hasInvalidEditedRow={hasInvalidEditedRow} handleResetRow={handleResetRow}/>
  );
};


const CalendarGrid = ({competition, teams = [], matchs = [], editedRows, handleRowChange, setLoading, handleSave, hasInvalidEditedRow, rowErrors, handleResetRow}) => {

    const classes = useStyles()

    //TODO REPLACE BY GENERATE MATCH DATA FUNCTION if it works
    const getData = () => {
        const data = []
        const usedMatchs = []

        let rowId = 0

        const competitionDays = getDays(competition.nbDays, competition.nbTeamFinalPhase)
        const nbMatchPerStandardDay = Math.max(1, Math.ceil(teams.length/2))

        competitionDays.map(day => {
                const nbMatchPerDay = day.nbMatchPerDay ?? nbMatchPerStandardDay

                    for(var i=1 ; i <= nbMatchPerDay ; i++){
                        
                        const existingMatch = matchs.find(match => match.day == day.name && !usedMatchs.includes(match._id))
                        // Un match correspond a cette journée
                        if(existingMatch){
                            data.push({    
                                idMatch : existingMatch._id, 
                                day : existingMatch.day, 
                                dateTime : new Date(existingMatch.dateTime),
                                homeTeam : existingMatch.homeTeam, 
                                awayTeam : existingMatch.awayTeam,
                                rowId : rowId++})

                            usedMatchs.push(existingMatch._id)
                        }
                        // Aucun match ne correspond a cette journée
                        else{
                            data.push({    
                                idMatch : undefined, 
                                day : day.name, 
                                dateTime : new Date(), 
                                homeTeam : "", 
                                awayTeam : "",
                                rowId : rowId++})
                        }
                    }
        })

        return data
    }


    if(!competition || !teams.length)
        return ""

    return (
         <Box className="padding-wrapper">
            <Table
              sx={{
                width: '100%',
                borderCollapse: 'separate',
                borderSpacing: 0,
                border: '2px solid var(--color-light-grey)',
                borderRadius: '8px 8px 0px 0px',
                overflow: 'hidden',
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: 'var(--color-light-grey)',
                      padding: 0,
                      borderBottom: 'none',
                      width: { xs: '100%', sm: '10%' },
                    }}
                  >
                    <Grid container className="centered-wrapper" sx={{ px: 2, py: 1 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          padding: '5px',
                          color: 'var(--color-text)',
                          fontWeight: 'bold',
                          textTransform: 'uppercase',
                        }}
                      >
                        Journée
                      </Typography>
                    </Grid>
                  </TableCell>

                  <TableCell
                    sx={{
                      backgroundColor: 'var(--color-light-grey)',
                      padding: 0,
                      borderBottom: 'none',
                      width: { xs: '100%', sm: '30%' },
                    }}
                  >
                    <Grid container className="centered-wrapper" sx={{ px: 2, py: 1 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          padding: '5px',
                          color: 'var(--color-text)',
                          fontWeight: 'bold',
                          textTransform: 'uppercase',
                        }}
                      >
                        Date
                      </Typography>
                    </Grid>
                  </TableCell>

                  <TableCell
                    sx={{
                      backgroundColor: 'var(--color-light-grey)',
                      padding: 0,
                      borderBottom: 'none',
                      width: { xs: '100%', sm: '30%' },
                    }}
                  >
                    <Grid container className="centered-wrapper" sx={{ px: 2, py: 1 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          padding: '5px',
                          color: 'var(--color-text)',
                          fontWeight: 'bold',
                          textTransform: 'uppercase',
                        }}
                      >
                        Équipe domicile
                      </Typography>
                    </Grid>
                  </TableCell>

                  <TableCell
                    sx={{
                      backgroundColor: 'var(--color-light-grey)',
                      padding: 0,
                      borderBottom: 'none',
                      width: { xs: '100%', sm: '30%' },
                    }}
                  >
                    <Grid container className="centered-wrapper" sx={{ px: 2, py: 1 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          padding: '5px',
                          color: 'var(--color-text)',
                          fontWeight: 'bold',
                          textTransform: 'uppercase',
                        }}
                      >
                        Équipe extérieure
                      </Typography>
                    </Grid>
                  </TableCell>
                </TableRow>
              </TableHead>


                {<VirtualizedTbody isDisabledEdition={competition.thirdPartyId && !['dsas'].includes(competition.thirdPartyId)} dataTable={getData()} editedRows={editedRows} teams={teams} classes={classes} handleRowChange={handleRowChange} rowErrors={rowErrors} handleResetRow={handleResetRow}/>}

            </Table>

            <Box className='medium-padding centered-wrapper'>
                <DsasButton 
                    label={`Valider ${ editedRows.length > 0 ? (`${editedRows.length} match${editedRows.length>1 ? "s" : ""}`) : ""}`} 
                    variant = 'alternative' 
                    disabled={editedRows.length === 0 || hasInvalidEditedRow}
                    customCss={{width: 'auto', padding: '0.5rem', minWidth:'195px'}}
                    onClick={() => {setLoading(true) ; handleSave()}}
                />
            </Box>
        </Box>
    )

}

const ROW_HEIGHT = 76; // px
const BUFFER_ROWS = 5; // lignes supplémentaires pour éviter le "clignotement"

const VirtualizedTbody = ({ dataTable, editedRows, teams, classes, handleRowChange, containerHeight = 600, isDisabledEdition, rowErrors, handleResetRow }) => {

    const {getPermission} = usePermissions()

  const containerRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);

  const totalHeight = dataTable.length * ROW_HEIGHT;

  const handleScroll = useCallback(() => {
    if (containerRef.current) {
      setScrollTop(containerRef.current.scrollTop);
    }
  }, []);

  useEffect(() => {
    const current = containerRef.current;
    if (current) current.addEventListener('scroll', handleScroll);
    return () => current?.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const startIndex = Math.max(0, Math.floor(scrollTop / ROW_HEIGHT) - BUFFER_ROWS);
  const endIndex = Math.min(dataTable.length, startIndex + Math.ceil(containerHeight / ROW_HEIGHT) + 2 * BUFFER_ROWS);

  const visibleRows = useMemo(() => {
  return dataTable.slice(startIndex, endIndex).map(row => {
    const edited = editedRows.find(e => e.rowId === row.rowId);
    return edited ? { ...row, ...edited } : row;
  });
}, [dataTable, editedRows, startIndex, endIndex]);

  return (
    <TableBody sx={{border: '2px solid var(--color-light-grey)'}}>
      <TableRow>
        <TableCell colSpan={4} sx={{ padding: 0, borderBottom: 'none' }}>
          <Box
            ref={containerRef}
            style={{
              maxHeight: containerHeight,
              overflowY: 'auto',
              position: 'relative',
              width: '100%'
            }}
          >
            <Box style={{ height: totalHeight, position: 'relative' }}>
              {visibleRows.map((row, idx) => {
                const isEdited = editedRows.some(e => e.rowId === row.rowId);
                const actualIndex = startIndex + idx;
                return (
                  <Grid
                    container
                    spacing={3.5}
                    key={row.rowId}
                    sx={{
                      marginLeft:0,
                      marginTop:0,
                      position: 'absolute',
                      top: actualIndex * ROW_HEIGHT,
                      width: '100%'
                    }}
                  >
                    <Grid item xs={12} sm={1} sx={{}}>
                      <TextField
                        className={classes.customInput}
                        fullWidth
                        select
                        disabled
                        label=""
                        name="day"
                        value={row.day || ''}
                      >
                        <MenuItem key={row.day} value={row.day}>
                          {row.day}
                        </MenuItem>
                      </TextField>
                    </Grid>

                    <Grid item xs={12} sm sx={{ display: 'inline-flex', gap: 1 }}>
                      <TextField
                        className={classes.customInput}
                        fullWidth
                        type="date"
                        label=""
                        name="date"
                        disabled={!getPermission(PERMISSIONS.SPORT_CALENDAR_HOME_INPUT_DATE).allowed}
                        value={formatDateOnly(row.dateTime)}
                        onChange={(e) => handleRowChange(row, e.target.name, e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                        className={classes.customInput}
                        fullWidth
                        type="time"
                        label=""
                        name="time"
                        disabled={!getPermission(PERMISSIONS.SPORT_CALENDAR_HOME_INPUT_DATE).allowed}
                        value={formatTimeOnly(row.dateTime)}
                        onChange={(e) => handleRowChange(row, e.target.name, e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>

                    <Grid item xs={12} sm sx={{}}>
                      <TextField
                        className={classes.customInput}
                        fullWidth
                        select
                        error={!!rowErrors?.[row.rowId]?.homeTeam}
                        helperText={rowErrors?.[row.rowId]?.homeTeam || ''}
                        disabled={isDisabledEdition || !getPermission(PERMISSIONS.SPORT_CALENDAR_HOME_INPUT_TEAM).allowed}
                        label=""
                        name="homeTeam"
                        value={row.homeTeam || ''}
                        onChange={(e) => handleRowChange(row, e.target.name, e.target.value)}
                      >
                        {teams.map((team) => (
                          <MenuItem key={team._id} value={team._id}>
                            {team.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid item xs={12} sm sx={{paddingRight: '28px', display:'flex', flexDirection:'row'}}>
                      <TextField
                        className={classes.customInput}
                        fullWidth
                        select
                        error={!!rowErrors?.[row.rowId]?.awayTeam}
                        helperText={rowErrors?.[row.rowId]?.awayTeam || ''}
                        disabled={isDisabledEdition || !getPermission(PERMISSIONS.SPORT_CALENDAR_HOME_INPUT_TEAM).allowed}
                        label=""
                        name="awayTeam"
                        value={row.awayTeam || ''}
                        onChange={(e) => handleRowChange(row, e.target.name, e.target.value)}
                      >
                        {teams.map((team) => (
                          <MenuItem key={team._id} value={team._id}>
                            {team.name}
                          </MenuItem>
                        ))}
                      </TextField>
                      <Tooltip title="Annuler les modifications" >
                          <Button
                            size="medium"
                            sx={{margin: 0, marginLeft: '25px', border: '1px solid #80808085', maxHeight: '56px'}}
                            onClick={() => handleResetRow(row.rowId)}
                            disabled={!isEdited}
                          >
                            <RestartAltIcon fontSize="small" />
                          </Button>
                      </Tooltip>
                    </Grid>
                  </Grid>
                );
              })}
            </Box>
          </Box>
        </TableCell>
      </TableRow>
    </TableBody>
  );
};

const CARD_HEIGHT = 315;
const MOBILE_BUFFER_ROWS = 3;

const VirtualizedCardRow = ({ dataTable, editedRows, teams, classes, handleRowChange, isDisabledEdition, setLoading, handleSave, rowErrors, hasInvalidEditedRow, handleResetRow }) => {
  const {getPermission} = usePermissions()
  const [scrollTop, setScrollTop] = useState(0);
  const [viewportHeight, setViewportHeight] = useState(typeof window !== 'undefined' ? window.innerHeight : 600);

  useEffect(() => {
    const handleScroll = () => setScrollTop(window.scrollY);
    const handleResize = () => setViewportHeight(window.innerHeight);

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    handleScroll();
    handleResize();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const totalHeight = dataTable.length * CARD_HEIGHT;

  const startIndex = Math.max(0, Math.floor(scrollTop / CARD_HEIGHT) - MOBILE_BUFFER_ROWS);
  const endIndex = Math.min(
    dataTable.length,
    startIndex + Math.ceil(viewportHeight / CARD_HEIGHT) + 2 * MOBILE_BUFFER_ROWS
  );

  const visibleRows = useMemo(() => {
    return dataTable.slice(startIndex, endIndex).map(row => {
      const edited = editedRows.find(e => e.rowId === row.rowId);
      return edited ? { ...row, ...edited } : row;
    });
  }, [dataTable, editedRows, startIndex, endIndex]);


    const renderRow = (row, idx, previousRow) => {

    const offsetIndex = startIndex + idx;
    const showDaySeparator = previousRow && row.day !== previousRow.day;
    const isEdited = editedRows.some(e => e.rowId === row.rowId);

    return (
      <div
        key={row.rowId}
        style={{
          position: 'absolute',
          top: offsetIndex * CARD_HEIGHT,
          width: '100%'
        }}
      >
        {showDaySeparator && (
          <Box
            sx={{
              marginTop: '-5px',
              marginBottom: '10px',
              marginLeft: '0px',
              marginRight: '0px',
              width: '100%',
              border: '1px solid var(--color-light-grey)',
              height: '15px',
              borderRadius: '8px 8px 0 0',
              backgroundColor: 'var(--color-light-grey)',
            }}
          />
        )}

        <Box sx={{ mb: 2, p: 2, pl:0, pr:0 }}>

          <Grid container spacing={1}>
                    <Grid item xs={3}>
                     <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold', textTransform: 'uppercase' }}>
                        Journée
                      </Typography>
                        <TextField
                        className={classes.customInput}
                        fullWidth
                        select
                        disabled
                        label=""
                        name="day"
                        value={row.day || ''}
                        size="small"
                      >
                        <MenuItem key={row.day} value={row.day}>
                          {row.day}
                        </MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={9}>
                     <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold', textTransform: 'uppercase'  }}>
                        Date
                      </Typography>
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                           <TextField
                          className={classes.customInput}
                          type="date"
                          fullWidth
                          size="small"
                          disabled={!getPermission(PERMISSIONS.SPORT_CALENDAR_HOME_INPUT_DATE).allowed}
                          value={formatDateOnly(row.dateTime)}
                          onChange={(e) => handleRowChange(row, 'date', e.target.value)}
                        />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                          className={classes.customInput}
                          type="time"
                          fullWidth
                          size="small"
                          disabled={!getPermission(PERMISSIONS.SPORT_CALENDAR_HOME_INPUT_DATE).allowed}
                          value={formatTimeOnly(row.dateTime)}
                          onChange={(e) => handleRowChange(row, 'time', e.target.value)}
                        />
                        </Grid>
                      </Grid>
                      
                    </Grid>
          </Grid>

          <Box className='medium-padding'></Box>

          <Grid container spacing={1} sx={{paddingTop:'15px'}}>
                    <Grid item xs={6}>
                     <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold', textTransform: 'uppercase'  }}>
                        Équipe domicile
                      </Typography>
                       <TextField
                          select
                          className={classes.customInput}
                          value={row.homeTeam || ''}
                          error={!!rowErrors?.[row.rowId]?.homeTeam}
                          helperText={rowErrors?.[row.rowId]?.homeTeam || ''}
                          disabled={isDisabledEdition || !getPermission(PERMISSIONS.SPORT_CALENDAR_HOME_INPUT_TEAM).allowed}
                          onChange={(e) => handleRowChange(row, 'homeTeam', e.target.value)}
                          fullWidth
                          size="small"
                        >
                          {teams.map(t => (
                            <MenuItem key={t._id} value={t._id}>{t.name}</MenuItem>
                          ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={6}>
                     <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold', textTransform: 'uppercase'  }}>
                        Équipe extérieure
                      </Typography>
                       <TextField
                          select
                          className={classes.customInput}
                          value={row.awayTeam || ''}
                          error={!!rowErrors?.[row.rowId]?.awayTeam}
                          helperText={rowErrors?.[row.rowId]?.awayTeam || ''}
                          disabled={isDisabledEdition || !getPermission(PERMISSIONS.SPORT_CALENDAR_HOME_INPUT_TEAM).allowed}
                          onChange={(e) => handleRowChange(row, 'awayTeam', e.target.value)}
                          fullWidth
                          size="small"
                        >
                          {teams.map(t => (
                            <MenuItem key={t._id} value={t._id}>{t.name}</MenuItem>
                          ))}
                        </TextField>
                    </Grid>
          </Grid>
          <Box className='medium-padding'>
          <Tooltip title="Annuler les modifications">
            <Box className='centered-wrapper'>
              <Button
                size="medium"
                sx={{margin: 0, marginTop:'15px', border: '1px solid #80808085'}}
                onClick={() => handleResetRow(row.rowId)}
                disabled={!isEdited}
              > Reset
                <RestartAltIcon fontSize="small" />
              </Button>
            </Box>
          </Tooltip>
          </Box>
          <Box className='medium-padding'></Box>
          <Box className='large-separator'></Box>
        </Box>
      </div>
    );
  };

  return (
    <>

    {/* Bouton "Aller en bas" en haut de la page */}
    <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
      <DsasButton 
        label={`Aller en bas`} 
        variant = 'elevator' 
        icon={faAngleDown}
        customCss={{marginBottom:0}}
        onClick={() => {
          window.scrollTo({ top: totalHeight, behavior: 'smooth' });
        }}
      />
    </Box>

      {/* Liste virtualisée */}
    <div style={{ position: 'relative', height: `${totalHeight}px` }}>
      {visibleRows.map((row, idx) => {
        const previousRow = idx > 0 ? visibleRows[idx - 1] : null;
        return renderRow(row, idx, previousRow);
      })}
    </div>
    

    {/* Bouton "Aller en haut" tout en bas de la page */}
    {/*top: `${totalHeight + 16}px` */}
    <Box sx={{ position: 'relative', width: '100%', textAlign: 'center' }}>
      <>
       <Box className='medium-padding centered-wrapper'>
          <DsasButton 
              label={`Valider ${ editedRows.length > 0 ? (`${editedRows.length} match${editedRows.length>1 ? "s" : ""}`) : ""}`} 
              variant = 'alternative' 
              disabled={editedRows.length === 0 || hasInvalidEditedRow}
              customCss={{width: 'auto', padding: '0.5rem', minWidth:'195px'}}
              onClick={() => {setLoading(true) ; handleSave()}}
          />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <DsasButton 
          label={`Aller en haut`} 
          variant = 'elevator' 
          icon={faAngleUp}
          customCss={{marginTop:0}}
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          />
        </Box>
      </>
    </Box>

  </>
  );
};


export default Calendar